<template>
<el-dialog class="acceptProposal" :visible.sync="dialogVisible" top="0" :before-close="closeModal" width="569px">
    <div class="w-100">
        <div class="pt-2 px-2 mt-5">
            <div class="d-flex justify-content-center mb-2">
                <AlertExclamationRegister />
            </div>
            <h3 class="c-ndarkthree bold mb-2 text-center">
                Você já possui cadastro na plataforma!
            </h3>
            <p class="c-ndarkfour text-center">
                Para entrar, você só precisa inserir o e-mail e senha que normalmente <br>
                usa para acessar a plataforma {{ getWhiteLabel | capitalizeFirstLetter }}. Caso tenha perdido a senha de <br>
                acesso, você pode solicitar a alteração ao clicar no link <span class="c-ndarkthree">Recuperar senha</span> <br>
                na tela de login.
            </p>
        </div>
    </div>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link :class="`mr-4 c-ndarkfour`" to="" @click.native="closeModal()">
            Fechar
        </router-link>

        <Button @click="goToLogin" :color="getPrimaryColor">
            Ir para login
        </Button>
    </span>
</el-dialog>
</template>

<script>
import AlertExclamationRegister from '@/components/icons/AlertExclamationRegister'
export default {
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    components: {
        AlertExclamationRegister,
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        goToLogin() {
            window.location.href = `${this.getServiceUrls.CLIENT}/`
        }
    }

}
</script>

<style lang="scss">
</style>
